module.exports = __webpack_public_path__ + "img/constructor.e92df77d.svg";